/**
 * Created by Bart Decorte
 * Date: 06/07/2020
 * Time: 11:44
 */
import Toast from './Toast';

export default class InfoToast extends Toast {
  constructor(body, header) {
    super(body, header);
    this.ariaLive = 'assertive';
  }

  iconMarkup() {
    return `
      <span class="text-info mr-2">
        <i class="fe fe-info"></i>
      </span>
    `
  }
}




// WEBPACK FOOTER //
// ./resources/assets/js/toasts/InfoToast.js